/**
 * plugins/vuetify.ts
 *
 * Framework documentation: https://vuetifyjs.com`
 */

// Styles
import '@mdi/font/css/materialdesignicons.css'
import 'vuetify/styles'
import '@/styles/font-display-overrides.css'

// Composables
import { createVuetify } from 'vuetify'
import { VDateInput } from 'vuetify/labs/VDateInput'
import { da } from 'vuetify/locale'
import { aliases, mdi } from 'vuetify/iconsets/mdi'

export default createVuetify({
  defaults: {
    VBtn: {
      class: 'text-none',
      flat: true,
      rounded: 'lg',
    },
    VTextField: {
      variant: 'outlined',
      density: 'comfortable',
      color: 'primary',
      hideDetails: true,
      rounded: 'lg',
    },
    VSelect: {
      variant: 'outlined',
      density: 'comfortable',
      color: 'primary',
      hideDetails: true,
      rounded: 'lg',
    },
    VCombobox: {
      variant: 'outlined',
      density: 'comfortable',
      color: 'primary',
      hideDetails: true,
      rounded: 'lg',
    },
    VTextarea: {
      variant: 'outlined',
      density: 'comfortable',
      color: 'primary',
      hideDetails: true,
      rounded: 'lg',
    },
    VCard: {
      rounded: 'xl',
      flat: true,
    },
    VChip: {
      rounded: 'lg',
    },
    VTooltip: {
      theme: 'light',
    },
    VBreadCrumb: {
      color: 'primary',
    },
  },
  theme: {
    themes: {
      light: {
        colors: {
          background: '#f1f5f9',
          surface: '#ffffff',
          primary: '#1565C0',
          'primary-darken-1': '#0d47a1',
          secondary: '#64748b',
          info: '#0284c7',
          success: '#16a34a',
          warning: '#d97706',
          error: '#dc2626',
          'on-surface-variant': '#475569',
        },
      },
    },
  },
  components: {
    VDateInput,
  },
  locale: {
    locale: 'da',
    fallback: 'da',
    messages: { da },
  },
  icons: { defaultSet: 'mdi', aliases, sets: { mdi } },
})
